<template>
    <transition
        name="page"
        class="GlobalLoader"
        mode="out-in"
        @:after-leave="animationFinished"
    >
        <div
            v-show="showGlobalLoader"
            class="GlobalLoader-mask"
        >
            <div class="GlobalLoader-loaderContainer">
                <div class="GlobalLoader-image">
                    <lottie
                        :options="lottieOptions"
                        @animCreated="handleAnimation"
                    />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import lottie from 'vue-lottie/src/lottie.vue'
import * as animationData from "@/assets/lottie/loader.json"

export default {
    components: {
        lottie
    },
    props: {
        showGlobalLoader: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            anim: null, // for saving the reference to the animation
            lottieOptions: { animationData: animationData.default }
        }
    },
    watch: {
        showGlobalLoader (val) {
            if (val) {
                document.body.classList.add('body--withModalOpened')
            } else {
                document.body.classList.remove('body--withModalOpened')
            }
        }
    },
    methods: {
        animationFinished () {
            this.$emit('animationFinished')
        },
        handleAnimation (anim) {
            this.anim = anim
        }
    }
}
</script>

<style lang='scss' scoped>

.GlobalLoader {
    z-index: 999;

    &-mask {
        @include containerMask;
        background: none;
        background-image: url('../../assets/images/background-big.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-color: $f2m-purple-dark;
    }

    &-loaderContainer {
        @include verticalCenter;

        width: 100%;
        height: 100%;
        justify-content: center;
    }

    &-image {
        width: 120px;
        height: 120px;
    }
}
</style>
